// import TablePagination from "@/components/table/pagination";
import PermissionsLists from "@/config/PermissionsLists";
import { EndPoints, httpService, Operation } from "@/Core/Client";
import { CityFormDto, cityFormSchema, CityResponseDto } from "@/Dtos/city-dto";
import { useState } from "react";

// import TablePagination from "@/components/table/pagination";
import { Config } from "@/components/crud/crud-config";
import CrudFormElements from "@/components/crud/crud-form-elements";
import CrudPage from "@/components/crud/page";
import PencilIcon from "@/components/icons/pencil";
import TableActions from "@/components/table-actions";
import { DATE_FORMAT_OPTIONS } from "@/Core/Helpers/DayjsHelpers";
import DateCell from "@/ui/date-cell";
import { useQueryClient } from "@tanstack/react-query";
import { createColumnHelper } from "@tanstack/react-table";
import { Checkbox } from "rizzui";
import { useModal } from "../shared/modal-views/use-modal";

const config: Config<CityResponseDto, CityFormDto> = {
    endPoint: EndPoints.city.crud,
    queryKey: ["cities"],
    columns: [],
    validationSchema: cityFormSchema,
    fields: [
        {
            name: "countryId",
            label: "Country",
            type: "referTo",
            hasFilter: true,
            // className: "w-auto",
            referEndPoint: EndPoints.country.referTo,
            filter: {
                operation: Operation.like,
                // showOperations: true,
            },
        },
        {
            name: "name",
            label: "Name",
            type: "text",
            hasFilter: true,
            // className: "w-auto",
            filter: {
                operation: Operation.like,
                // showOperations: true,
            },
        },
        {
            name: "createdAt",
            label: "Created At",
            type: "date",
            hasFilter: true,
            filterOnly: true,
            dateFormat: DATE_FORMAT_OPTIONS.L,
            // className: "w-auto",
            filter: {
                operation: Operation.gte,
                // showOperations: true,
            },
        },
    ],
    titles: {
        pageTitle: "Cities",
    },
    filterProps: {
        useDrawer: true,
        // ignoreSorting: true,
        sortingClassName: "w-auto",
        // sortingMinWidth: "10px",
        directionClassName: "w-auto",
        // directionMinWidth: "10px",
    },

    permissionsCreate: PermissionsLists.Country.Create,
    formOptions: {
        customSize: "750px",
    },
};

const columnHelper = createColumnHelper<CityResponseDto>();

export const columns = [
    columnHelper.display({
        id: "select",
        size: 50,
        header: ({ table }) => (
            <Checkbox
                className="ps-3.5"
                aria-label="Select all Rows"
                checked={table.getIsAllPageRowsSelected()}
                onChange={() => table.toggleAllPageRowsSelected()}
            />
        ),
        cell: ({ row }) => (
            <Checkbox
                className="ps-3.5"
                aria-label="Select Row"
                checked={row.getIsSelected()}
                onChange={row.getToggleSelectedHandler()}
            />
        ),
    }),
    columnHelper.display({
        id: "id",
        size: 100,
        header: "#",
        cell: ({ row }) => <>{row.index + 1}</>,
    }),
    columnHelper.accessor("name", {
        id: "name",
        size: 130,
        header: "Name",
        cell: ({ row }) => row.original.name,
    }),
    columnHelper.accessor("country.name", {
        id: "country.name",
        size: 130,
        header: "Country",
        cell: ({ row }) => row.original?.country?.name,
    }),
    columnHelper.accessor("createdAt", {
        id: "createdAt",
        size: 130,
        header: "Created",
        cell: ({ row }) => (
            <DateCell
                date={new Date(Date.parse(row.original?.createdAt ?? ""))}
            />
        ),
    }),
    columnHelper.display({
        id: "actions",
        size: 80,
        cell: ({ row }) => {
            const { openModal } = useModal();
            const [isLoading, setLoading] = useState(false);
            const queryClient = useQueryClient();

            return (
                <TableActions
                    row={row.original}
                    onDelete={() => {
                        setLoading(true);
                        httpService(config.endPoint).delete(row.original.id!);
                        queryClient.refetchQueries({
                            queryKey: config.queryKey,
                        });
                        setLoading(false);
                    }}
                    actions={[
                        {
                            title: "View",
                            color: "gray",
                            isLoading: isLoading,
                            icon: <PencilIcon className="size-4" />,
                            onClick: () =>
                                openModal({
                                    view: (
                                        <CrudFormElements<
                                            CityResponseDto,
                                            CityFormDto
                                        >
                                            editData={row.original}
                                            config={config}
                                        />
                                    ),
                                    customSize: config.formOptions?.customSize,
                                }),
                        },
                    ]}
                />
            );
        },
    }),
];

config.columns = columns;

export default function MainPage() {
    return CrudPage<CityResponseDto, CityFormDto>({ config: config });
}
